export const POLEHEIGHT = "poleHeight";
export const STAYANGLE = "stayAngle";
export const POLETERMLENGTH = "poleTermLength";
export const POLELINK = "poleLink";
